import CreateNewUser from './CreateNewUser';

export default CreateNewUser;



// WEBPACK FOOTER //
// ./src/components/Pages/Account/CreateNewUser/index.js